import { render, staticRenderFns } from "./DashboardAreaSettingModal.vue?vue&type=template&id=1c21d9f6&scoped=true&"
import script from "./DashboardAreaSettingModal.vue?vue&type=script&lang=js&"
export * from "./DashboardAreaSettingModal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAreaSettingModal.vue?vue&type=style&index=0&id=1c21d9f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c21d9f6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c21d9f6')) {
      api.createRecord('1c21d9f6', component.options)
    } else {
      api.reload('1c21d9f6', component.options)
    }
    module.hot.accept("./DashboardAreaSettingModal.vue?vue&type=template&id=1c21d9f6&scoped=true&", function () {
      api.rerender('1c21d9f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/modal/DashboardAreaSettingModal.vue"
export default component.exports